module.exports = __webpack_public_path__ + "img/publications-frame.a7351f3e.gif";